export default "__VITE_ASSET__Dk3Hnhz8__"